import React from "react";
import Modal from "../../shared/components/Modal";
import VisitFormFields from "./VisitformFields";

/**
 * AddVisitModal
 *
 * Props:
 *   order         object  — the order this visit is being logged against
 *   form          visit form state
 *   setForm       (updater) => void
 *   docInput      string
 *   setDocInput   (val) => void
 *   uploading     bool
 *   saving        bool
 *   onFileUpload  (e: ChangeEvent) => void
 *   onSave        () => void
 *   onClose       () => void
 */
const AddVisitModal = React.memo(function AddVisitModal({
  order,
  form,
  setForm,
  docInput,
  setDocInput,
  uploading,
  saving,
  onFileUpload,
  onSave,
  onClose,
}) {
  return (
    <Modal title={`New Visit — ${order.id}`} onClose={onClose} maxWidth={440}>
      <div
        className="formInner"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 12,
          padding: "0 24px 24px",
        }}
      >
        <VisitFormFields
          form={form}
          setForm={setForm}
          docInput={docInput}
          setDocInput={setDocInput}
          uploading={uploading}
          saving={saving}
          onFileUpload={onFileUpload}
          submitLabel="Log Visit"
          onSubmit={onSave}
        />
      </div>
    </Modal>
  );
});

export default AddVisitModal;
